import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import { Grid, Row, Col } from "react-flexbox-grid"
import Play from "../components/play/play"
import { Spring, animated } from "react-spring/renderprops"
import $ from "jquery"
import "lightgallery"
import "lg-video"
import "lg-zoom"

import img_1 from "../images/exterior.jpg"
import img_2 from "../images/exterior1.jpg"
import img_3 from "../images/exterior2.jpg"
import img_4 from "../images/lobby.jpg"
import img_5 from "../images/pool.jpg"
import img_6 from "../images/social.jpg"
import img_7 from "../images/gym.jpg"
import img_8 from "../images/summer.jpg"
import img_9 from "../images/winter.jpg"
import img_10 from "../images/living.jpg"
import img_11 from "../images/closet.jpg"
import img_12 from "../images/kitchen.jpg"
import img_13 from "../images/kitchen2.jpg"
import img_14 from "../images/kitchen3.jpg"
import img_15 from "../images/bathroom.jpg"
import img_16 from "../images/bathroom2.jpg"

import "./gallery.sass"

class Gallery extends Component {
  onLightGallery = node => {
    this.lightGallery = node
    $(node).lightGallery()
  }

  componentWillUnmount() {
    $(this.lightGallery)
      .data("lightGallery")
      .destroy(true)
  }
  render() {
    return (
      <Layout>
        <SEO title="Gallery" />
        <Spring
          from={{ opacity: 0, transform: "translate3d(0, 30px, 0)" }}
          to={{ opacity: 1, transform: "translate3d(0, 0, 0)" }}
        >
          {props => (
            <animated.div style={props} id="gallery">
              <h1 className="page-title">gallery</h1>
              <div className="gallery-wrapper">
                <section className="gallery-section">
                  <Grid>
                    <h2 className="gallery-title">project videos</h2>
                    <Row center="xs">
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href="https://vimeo.com/345747277">
                            <Img
                              fluid={this.props.data.vid1.childImageSharp.fluid}
                            />
                            <Play />
                            <figcaption>The One and Only Location</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href="https://vimeo.com/345988385">
                            <Img
                              fluid={this.props.data.vid2.childImageSharp.fluid}
                            />
                            <Play />
                            <figcaption>Architectural Inspirations</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href="https://vimeo.com/345988862">
                            <Img
                              fluid={this.props.data.vid3.childImageSharp.fluid}
                            />
                            <Play />
                            <figcaption>
                              Amenities beyond your imagination
                            </figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href="https://vimeo.com/345988715">
                            <Img
                              fluid={this.props.data.vid4.childImageSharp.fluid}
                            />
                            <Play />
                            <figcaption>design beyond compare</figcaption>
                          </figure>
                        </div>
                      </Col>
                    </Row>
                  </Grid>
                </section>
                <section className="gallery-section">
                  <Grid>
                    <h2 className="gallery-title">project images</h2>
                    <Row center="xs" start="lg">
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_1}>
                            <Img
                              fluid={
                                this.props.data.exterior.childImageSharp.fluid
                              }
                            />
                            <figcaption>building exterior</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_2}>
                            <Img
                              fluid={
                                this.props.data.exterior1.childImageSharp.fluid
                              }
                            />
                            <figcaption>building exterior</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_3}>
                            <Img
                              fluid={
                                this.props.data.exterior2.childImageSharp.fluid
                              }
                            />
                            <figcaption>outdoor terrace</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_4}>
                            <Img
                              fluid={
                                this.props.data.lobby.childImageSharp.fluid
                              }
                            />
                            <figcaption>lobby</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_5}>
                            <Img
                              fluid={this.props.data.pool.childImageSharp.fluid}
                            />
                            <figcaption>swimming pool</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_6}>
                            <Img
                              fluid={
                                this.props.data.social.childImageSharp.fluid
                              }
                            />
                            <figcaption>social lounge</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_7}>
                            <Img
                              fluid={this.props.data.gym.childImageSharp.fluid}
                            />
                            <figcaption>gym</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_8}>
                            <Img
                              fluid={
                                this.props.data.summer.childImageSharp.fluid
                              }
                            />
                            <figcaption>water garden</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_9}>
                            <Img
                              fluid={
                                this.props.data.winter.childImageSharp.fluid
                              }
                            />
                            <figcaption>skating rink</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_10}>
                            <Img
                              fluid={
                                this.props.data.living.childImageSharp.fluid
                              }
                            />
                            <figcaption>living room</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_11}>
                            <Img
                              fluid={
                                this.props.data.closet.childImageSharp.fluid
                              }
                            />
                            <figcaption>closet</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_12}>
                            <Img
                              fluid={
                                this.props.data.kitchen.childImageSharp.fluid
                              }
                            />
                            <figcaption>kitchen</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_13}>
                            <Img
                              fluid={
                                this.props.data.kitchen2.childImageSharp.fluid
                              }
                            />
                            <figcaption>kitchen</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_14}>
                            <Img
                              fluid={
                                this.props.data.kitchen3.childImageSharp.fluid
                              }
                            />
                            <figcaption>kitchen</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_15}>
                            <Img
                              fluid={this.props.data.bath.childImageSharp.fluid}
                            />
                            <figcaption>bathroom</figcaption>
                          </figure>
                        </div>
                      </Col>
                      <Col xs={11} md={6} lg={3}>
                        <div className="img-tn" ref={this.onLightGallery}>
                          <figure href={img_16}>
                            <Img
                              fluid={
                                this.props.data.bath2.childImageSharp.fluid
                              }
                            />
                            <figcaption>bathroom storage</figcaption>
                          </figure>
                        </div>
                      </Col>
                    </Row>
                  </Grid>
                </section>
              </div>
            </animated.div>
          )}
        </Spring>
      </Layout>
    )
  }
}

export default Gallery

export const galleryQuery = graphql`
  query {
    exterior: file(relativePath: { eq: "exterior.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    exterior1: file(relativePath: { eq: "exterior1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    exterior2: file(relativePath: { eq: "exterior2tn.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    lobby: file(relativePath: { eq: "lobby.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    pool: file(relativePath: { eq: "pool.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    social: file(relativePath: { eq: "social.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    summer: file(relativePath: { eq: "summer.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    winter: file(relativePath: { eq: "winter.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    gym: file(relativePath: { eq: "gym.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    living: file(relativePath: { eq: "living.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    kitchen: file(relativePath: { eq: "kitchen.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    kitchen2: file(relativePath: { eq: "kitchen2tn.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    kitchen3: file(relativePath: { eq: "kitchen3tn.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bath: file(relativePath: { eq: "bathroomtn.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bath2: file(relativePath: { eq: "bathroom2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    closet: file(relativePath: { eq: "closettn.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    vid1: file(relativePath: { eq: "vid1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    vid2: file(relativePath: { eq: "vid2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    vid3: file(relativePath: { eq: "vid3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    vid4: file(relativePath: { eq: "vid4.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
